/* LEDI Modular platform PDP: variant selection, live specs, add to cart. */
(function () {
  var TBC = 'To be confirmed';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Same markup as snippets/lmp-rows.liquid
  function rowsHTML(text) {
    var rows = String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    if (!rows.length) return '<p class="lmp-tbc">' + TBC + '</p>';
    return '<table class="lmp-rows"><tbody>' + rows.map(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      return '<tr><th scope="row">' + esc(p[0]) + '</th><td>' + p.slice(1).map(esc).join(' · ') + '</td></tr>';
    }).join('') + '</tbody></table>';
  }


  // True-size AR viewer. Loads model-viewer only when the section comes near the
  // viewport, and limits the module list to the models that match the selected
  // configuration (CAT pump, 2540 vessel, or the CAT + one-2540 plumbed layout).
  function initAR(root) {
    var sec = root.querySelector('[data-lmp-ar]');
    if (!sec) return null;
    var mv = sec.querySelector('[data-lmp-mv]');
    var parts = Array.prototype.slice.call(sec.querySelectorAll('.lmp-ar__part'));
    var caption = sec.querySelector('[data-lmp-ar-caption]');
    var note = sec.querySelector('[data-lmp-ar-note]');
    var placeBtns = sec.querySelectorAll('[data-lmp-place]');
    var brand = sec.dataset.brand;
    var current = null, userPlace = null;

    function ok(btn, mem) {
      var n = btn.dataset.needs;
      if (n === 'cat') return brand === 'cat';
      if (n === '2540') return mem.indexOf('2540') > -1;
      if (n === 'full') return brand === 'cat' && mem.indexOf('1 ×') === 0 && mem.indexOf('2540') > -1;
      return true;
    }
    function setPlace(p) {
      mv.setAttribute('ar-placement', p);
      placeBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.lmpPlace === p)); });
    }
    function resetView() {
      mv.cameraOrbit = '0deg 78deg auto';
      mv.fieldOfView = 'auto';
      mv.cameraTarget = 'auto auto auto';
    }
    function select(btn) {
      current = btn;
      parts.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      mv.setAttribute('src', btn.dataset.src);
      mv.setAttribute('alt', btn.dataset.alt);
      caption.textContent = btn.dataset.caption;
      setPlace(userPlace || btn.dataset.place);
      if (mv.cameraOrbit !== undefined) resetView();
    }
    function update(mem, ctl) {
      var first = null;
      parts.forEach(function (b) {
        var show = ok(b, mem) && !(b.dataset.part === 'panel' && ctl === 'Local control');
        b.hidden = !show;
        if (show && !first) first = b;
      });
      if (!current || current.hidden) select(first);
      var msg = '';
      if (brand !== 'cat') msg = '3D models of the Pumptec pump module and 2521 membrane are coming soon. The prefilters, remote panel and inlet are the same across the range.';
      else if (mem.indexOf('2540') === -1) msg = 'A 3D model of the 2521 membrane vessel is coming soon.';
      else if (mem.indexOf('2 ×') === 0) msg = 'Your layout uses two of these membrane vessels in series.';
      note.textContent = msg;
      note.hidden = !msg;
    }

    parts.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    placeBtns.forEach(function (b) {
      b.addEventListener('click', function () { userPlace = b.dataset.lmpPlace; setPlace(userPlace); });
    });
    var reset = sec.querySelector('[data-lmp-ar-reset]');
    if (reset) reset.addEventListener('click', resetView);

    function load() {
      if (window.customElements && customElements.get('model-viewer')) return;
      if (document.querySelector('script[data-lmp-model-viewer]')) return;
      var sc = document.createElement('script');
      sc.type = 'module';
      sc.src = 'https://unpkg.com/@google/model-viewer@4.0.0/dist/model-viewer.min.js';
      sc.setAttribute('data-lmp-model-viewer', '');
      document.head.appendChild(sc);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { load(); io.disconnect(); }
      }, { rootMargin: '600px 0px' });
      io.observe(sec);
    } else {
      load();
    }
    return { update: update };
  }

  function init(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-lmp-json]').textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var form = root.querySelector('[data-lmp-form]');
    var idInput = root.querySelector('[data-lmp-id]');
    var addBtn = root.querySelector('[data-lmp-add]');
    var addLabel = root.querySelector('[data-lmp-add-label]');
    var enquire = root.querySelector('[data-lmp-enquire]');
    var errorEl = root.querySelector('[data-lmp-error]');
    var mainImg = root.querySelector('.lmp-gallery__img');
    var model = root.dataset.model;
    var voltIdx = parseInt(root.dataset.voltIndex, 10) - 1;
    var memIdx = parseInt(root.dataset.memIndex, 10) - 1;
    var ctlIdx = parseInt(root.dataset.ctlIndex || '0', 10) - 1;
    var ar = initAR(root);

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-lmp-option]'), function (fs) {
        var r = fs.querySelector('input[type=radio]:checked');
        if (r) return r.value;
        var f = fs.querySelector('[data-lmp-fixed]');
        return f ? f.value : null;
      });
    }

    function find(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function setAll(sel, fn) {
      root.querySelectorAll(sel).forEach(fn);
    }

    function showImage(src, mediaId) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      setAll('[data-lmp-thumb]', function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId));
      });
    }

    function render(v, opts) {
      var volt = opts[voltIdx], mem = opts[memIdx], ctl = ctlIdx >= 0 ? opts[ctlIdx] : '';
      var config = model + ' · ' + volt + ' · ' + mem + (ctl ? ' · ' + ctl : '');
      setAll('[data-lmp-config]', function (el) { el.textContent = config; });
      setAll('[data-lmp-volt]', function (el) { el.textContent = volt + ' DC'; });
      setAll('[data-lmp-mem]', function (el) { el.textContent = mem; });
      setAll('[data-lmp-diagram]', function (el) { el.hidden = el.dataset.lmpDiagram !== mem; });
      if (ar) ar.update(mem, ctl);
      setAll('[data-lmp-ctl-spec]', function (el) { el.textContent = ctl === 'Local control' ? 'Local control: gauges and needle valve on the membrane module, 3D-printed switch module' : 'Remote control panel'; });

      if (!v) {
        idInput.value = '';
        addBtn.disabled = true;
        addLabel.textContent = 'Not available in this combination';
        return;
      }
      idInput.value = v.id;
      var priced = v.price > 0;
      var onReq = !!v.onRequest;
      setAll('[data-lmp-price]', function (el) { el.textContent = onReq ? 'Price on request' : (priced ? v.priceFmt : 'Price to be confirmed'); });
      setAll('[data-lmp-compare]', function (el) { el.hidden = !v.compareFmt; el.textContent = v.compareFmt || ''; });
      setAll('[data-lmp-sku]', function (el) { el.textContent = v.sku ? ' · SKU ' + v.sku : ''; });
      setAll('[data-lmp-sku-cell]', function (el) { el.textContent = v.sku || TBC; });
      setAll('[data-spec]', function (el) {
        var val = v.mf[el.dataset.spec];
        if (el.hasAttribute('data-optional')) { el.textContent = val || ''; el.hidden = !val; return; }
        el.textContent = val || TBC;
        el.classList.toggle('is-tbc', !val);
      });
      setAll('[data-spec-list]', function (el) { el.innerHTML = rowsHTML(v.mf[el.dataset.specList]); });

      addBtn.disabled = onReq || !(v.available && priced);
      addLabel.textContent = onReq ? (v.orderNote === 'Special order' ? 'Special order: enquire' : 'Available on request') : (!priced ? 'Pricing coming soon' : (v.available ? 'Add to cart' : 'Currently unavailable'));
      if (enquire) enquire.classList.toggle('lmp-btn--primary', onReq), enquire.classList.toggle('lmp-btn--ghost', !onReq);
      if (enquire) {
        var base = enquire.getAttribute('href').split('?')[0];
        enquire.href = base + '?product=' + encodeURIComponent(root.querySelector('.lmp-title').textContent.trim()) + '&config=' + encodeURIComponent(v.title);
      }
      if (v.image) showImage(v.image, v.mediaId);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    function update() {
      var opts = selected();
      render(find(opts), opts);
    }

    // Tag choices that only lead to on-request variants (e.g. Compact 24V).
    root.querySelectorAll('[data-lmp-option]').forEach(function (fs) {
      var idx = parseInt(fs.dataset.lmpOption, 10) - 1;
      fs.querySelectorAll('input[type=radio]').forEach(function (r) {
        var vs = variants.filter(function (v) { return v.options[idx] === r.value; });
        if (vs.length && vs.every(function (v) { return v.onRequest; })) {
          var tag = document.createElement('span');
          tag.className = 'lmp-choice__tag';
          tag.textContent = vs[0].orderNote || 'On request';
          r.nextElementSibling.appendChild(tag);
        }
      });
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-lmp-option] input[type=radio]')) update();
    });

    setAll('[data-lmp-thumb]', function (t) {
      t.addEventListener('click', function () { showImage(t.dataset.src, t.dataset.mediaId); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled || !idInput.value) return;
      errorEl.hidden = true;
      addBtn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      }).catch(function () {
        errorEl.hidden = false;
      }).finally(function () {
        addBtn.removeAttribute('aria-busy');
      });
    });

    // Sticky bar: show once the purchase panel has scrolled away.
    var sticky = root.querySelector('[data-lmp-sticky]');
    var buy = root.querySelector('.lmp-actions');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', off);
        sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        sticky.querySelector('a').tabIndex = off ? 0 : -1;
      }).observe(buy);
    }

    // Sync with ?variant= on load (Liquid already rendered it; this restores radio state after back/forward).
    update();
  }

  function boot() { document.querySelectorAll('[data-lmp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
